<template>
  <div class="site-view">
      <!-- <Header /> -->
      <HomeHeroHeader />
      <HomeVideoSection/>
      <section class="full-screen-banner hide-on-med-and-down">
        <img class="full-screen-banner" src="@/assets/images/Belfast/all/blue-banner.png" alt="" />
      </section>  

      <TwoColumnFooter/>
      <Footer />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import HomeVideoSection from "@/components/belfast/HomeVideoSection";
import TwoColumnFooter from "@/components/belfast/TwoColumnFooter";
import HomeHeroHeader from "@/components/belfast/HomeHeroHeader";
import Header from "@/components/belfast/Header";
import Footer from "@/components/belfast/Footer";
export default {
  name: "homePage",
  components: {
    HomeHeroHeader,
    Header,
    Footer,
    HomeVideoSection,
    TwoColumnFooter

  },
  data() {
    return {
       
      accordions: [
        {
          active: false,
          question: "Why does the A141 Matter?",
          answer: [
            "The A141 is the main road from the fens and it is crucial for the whole Huntingdon and St Ives area: north-east, it connects villages and towns within rural Fenland; west, it links the wider region via the A14 and the A1.",
          ],
        },
        {
          active: false,
          question: "What’s the problem?",
          answer: [
            "The A141 plays a key role in our road network but it can get severely congested, especially at peak times. Each day, thousands of us use the A141 to get to and from home, school, work and shops. The rise in long-distance container trucks crossing the region only adds to the road’s current problems. ",
            "People living and working in Huntingdon, and beyond, often travel by car, increasing pressure on the A141 and feeder roads.  Rat-runs through the villages create disturbance, and air and noise pollution for the community. " ,
            "The A141 is well-known for traffic jams that affect all road users, whether cycling, walking, travelling on buses and coaches,  or riding horses. ",
          ],
        },
      ],
      challenges: [
        {
          header: "Peak time congestion",
        },
        {
          header: "Unreliable journey times",
        },
        {
          header: "Road safety issues",
        },
        {
          header: "Rat-running on minor roads",
        },
        {
          header: " Lack of safe, off-road cycle route",
        },
        {
          header: "Lack of active travel options",
        },
        {
          header: "Air and noise quality issues due to congestion",
        },
        {
          header: "Limited provision for public transport",
        },
      ],
      concerns: [
        "An Air Quality Management Area (AQMA) within Huntingdon along the A1307, A141, B1044, B1514 and Huntingdon Inner Ring Road",
        "The Great Stukeley Railway Cutting ecological Site of Special Scientific Interest (SSSI) to the north of Huntingdon",
        "Two Grade II listed buildings and two scheduled monuments (Roman Barrows) around the village of Great Stukeley",
      ],
    };
  },

  methods: {
    accordionToggle(index) {
      let accordionElement = document.getElementById(`accordion_${index}`);

      if (!this.accordions[index].active) {
        accordionElement.classList.add("open");
        this.accordions[index].active = true;
      } else {
        accordionElement.classList.remove("open");
        this.accordions[index].active = false;
      }
    },
  },

  computed: {
    ...mapState(["entities", "entityTypes"]),
    ...mapGetters(["user", "allEntityTypes", "allEntities"]),
  },

  async mounted() {
    // this.populateTimeline();
    if (this.entities.length == 0) {
      await this.$store.dispatch("populateEntities");
    }
  },
};
</script>

